// hooks/useCodexCode.js
import { useEffect, useState } from "react";
import { getCode } from "../services/CodexAPI"; // Adjust the import path as needed

export function useCodexCode(version, codelist, longCode) {
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!version || !codelist || !longCode) return;

    const fetch = async () => {
      try {
        const result = await getCode(version, codelist, longCode);
        setCode(result);
      } catch (err) {
        console.error("Codex lookup failed:", err);
        setCode(null);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, [version, codelist, longCode]);

  return { code, loading };
}
